import styled from "styled-components";

export const ActivityContainer = styled.div`
  background-color: #1f2d3d;
  position: relative;
  width: 100%;
  padding: ${({ isMobileView }) => (isMobileView ? "24px 0" : "56px 0")};
  background-image: ${({ backgroundImage }) =>
    backgroundImage ? `url(${backgroundImage})` : "none"};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ActivityContainerOuter = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: ${({ isMobileView }) => (isMobileView ? "0 16px" : "0 100px")};
`;

export const ActivityTitle = styled.h1`
  color: #f0f2f9;
  font-size: ${({ isMobileView }) => (isMobileView ? "20px" : "40px")};
  font-weight: bold;
  margin-bottom: ${({ isMobileView }) => (isMobileView ? "16px" : "36px")};
  line-height: ${({ isMobileView }) => (isMobileView ? "1.45em" : "1.25em")};
  text-align: left;
  width: 100%;
`;

export const ActivityCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ isMobileView }) => (isMobileView ? "16px" : "24px")};
  width: 100%;
  overflow-x: auto;
  padding-bottom: 8px;

  /* Hide scrollbar but allow scrolling */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  ${({ isWrap }) =>
    isWrap &&
    `
    flex-wrap: wrap;
    justify-content: flex-start;
  `}
`;

export const CardWrapper = styled.div`
  flex: 0 0 auto;
  width: ${({ isMobileView, cardWidth }) =>
    cardWidth ? `${cardWidth}px` : isMobileView ? "280px" : "500px"};
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

export const Card = styled.div`
  border-radius: 16px;
  overflow: hidden;
  background-color: white;
  height: ${({ isMobileView }) => (isMobileView ? "380px" : "500px")};
  position: relative;
`;

export const CardImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: ${({ imgSrc }) => `url("${imgSrc}")`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const CardGradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70%;
  background: linear-gradient(
    to bottom,
    rgba(3, 151, 201, 0) 0%,
    rgba(3, 151, 201, 1) 82.5%
  );
`;

export const CardContent = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const CardTitle = styled.h3`
  color: white;
  font-size: ${({ isMobileView }) => (isMobileView ? "20px" : "28px")};
  font-weight: bold;
  margin: 0;
  line-height: ${({ isMobileView }) => (isMobileView ? "1.45em" : "1.14em")};
  white-space: pre-line;
`;

export const CircleButton = styled.div`
  width: ${({ isMobileView }) => (isMobileView ? "40px" : "56px")};
  height: ${({ isMobileView }) => (isMobileView ? "40px" : "56px")};
  border-radius: 28px;
  border: 1px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;

  svg {
    width: ${({ isMobileView }) => (isMobileView ? "20px" : "24px")};
    height: ${({ isMobileView }) => (isMobileView ? "20px" : "24px")};
  }
`;
